module.exports = __webpack_public_path__ + "img/logomid.f0f8308e.png";